// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__5M4ow","hideLogoOnHomePage":"Logo_hideLogoOnHomePage__74Iqq"};